import React, { Component } from 'react'
import styles from "./GatherPage.module.css"

// components
import ListShoots from "./CollectComponents/ListShoots"
import FuncBar from "./CollectComponents/FuncBar"
import ToolBar from "./CollectComponents/ToolBar"
import CollectMap from "./CollectComponents/CollectMap"
import CropImageContainer from "./CropImageContainer"

import COLLECT_REFRESH_ICON_SRC from "../static/icons8-refresh-500.png"
const CONTAINER_HEIGHT_OFFSET = 200
const DEFAULT_RGBA_SETTING = { color: "#43C6DB", alpha: 0.6 }

export default class GatherPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            pickStatus: { updateType: null }, //{updateType, ...data},
            searchImage: undefined,
            cropImageSrc: "",
            cropInfo: {},
            funcBarComp: undefined,
            swapIndex: 0,
            containerHeight: window.innerHeight,
            selectColor: { ...DEFAULT_RGBA_SETTING },
            toolColor: { ...DEFAULT_RGBA_SETTING },
        }

        this.swapBufferList = []
    }

    // Handler and callback
    swapBufferHandler = (e) => {
        this.setState(state => {
            var len = this.swapBufferList.length
            if (len != 0) {
                return {
                    swapIndex: (state.swapIndex + 1 >= len) ? 0 : (state.swapIndex + 1)
                }
            }
        })
    }
    gatherHandler = (e) => {
        this.props.gatherHandler(e)
    }
    setPickImgCallback = (data) => {
        this.setState(state => {
            return { pickStatus: { ...data } }
        }, () => {
            this.setState(state => { return { pickStatus: { updateType: null } } })
        })
    }
    gridHeightCallback = (height) => {
        this.setState(state => { return { containerHeight: height } })
    }
    toolBarColorCallback = ({ color = DEFAULT_RGBA_SETTING.color, alpha = DEFAULT_RGBA_SETTING.alpha }) => {
        this.setState(state => { return { toolColor: { color: color, alpha: alpha } } },
            () => { this.setState(state => { return { toolColor: { color: null, alpha: null } } }) })

    }
    toggleToolHandler = (data) => {
        this.setState(state => {
            return { pickStatus: { ...data } }
        }, () => {
            this.setState(state => { return { pickStatus: { updateType: null } } })
        })
    }
    colorPickHandler = (color, alpha) => {
        this.setState(state => { return { selectColor: { color: color, alpha: alpha } } })
    }
    cropCompleteCallback = (cropImageSrc, cropInfo) => {
        // mouse release
        this.setState(state => {
            return {
                cropImageSrc: cropImageSrc,
                cropInfo: cropInfo
            }
        })
    }
    // sub-components
    exhibitComponent = () => {
        const selfStyle = {
            width: "100%",
        }

        return (
            <div style={selfStyle}>
                <CollectMap pick={this.state.pickStatus} color={this.state.selectColor}
                    defaultRgba={DEFAULT_RGBA_SETTING}
                    gridHeightCallback={this.gridHeightCallback}
                    toolBarColorCallback={this.toolBarColorCallback} />
            </div>
        )
    }

    render() {

        const style = {
            height: `${parseInt(this.state.containerHeight) + CONTAINER_HEIGHT_OFFSET}px`
        }
        return (
            <div className={styles.container} style={style}>
                <div className={styles.containerBarStyle}>
                    <div className={styles.toolBarStyle}>
                        <ToolBar defaultColor={this.state.toolColor}
                            toggleToolHandler={this.toggleToolHandler}
                            colorPickHandler={this.colorPickHandler} />
                    </div>
                </div>
                <div className={styles.layoutContainerStyle}>
                    <ListShoots contentList={this.props.contentList} refreshHandler={this.gatherHandler} setImgCb={this.setPickImgCallback} />
                </div>
                <div className={styles.contentConainerStyle}>
                    {this.exhibitComponent()}
                </div>
            </div>
        )
    }
}
